import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  thumbnail: {
    width: '100%',
    height: 180,
    objectFit: 'cover',
  },
  thumbnailPlaceholder: {
    width: '100%',
    height: 180,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.disabled,
  },
  body: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(1.5),
  },
  categories: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  chip: {
    fontSize: 11,
    height: 22,
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.3,
    color: theme.palette.text.primary,
    flex: 1,
  },
  meta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  metaText: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: 'auto',
  },
  accessButton: {
    textTransform: 'none',
    fontWeight: 600,
    flex: 1,
  },
  linkButton: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.75),
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
}))

export default useStyles
